import { ArticleCommentPolicy } from '../enums';

export interface Article {
  id: string;
  postId: string;
  title: string;
  subtitle: string | null;
  slug: string | null;
  excerpt: string;
  coverUrl: string | null;
  coverKey: string | null;
  bodyJson: unknown;
  bodyText: string;
  seoTitle: string | null;
  seoDescription: string | null;
  commentPolicy: ArticleCommentPolicy;
  readTimeMinutes: number;
  topics: string[] | null;
  createdAt: Date;
  updatedAt: Date;
}

/** Media limits for article body + cover (per-file size matches social posts). */
export const ARTICLE_IMAGE_MAX_COUNT = 20;
export const ARTICLE_IMAGE_MAX_BYTES = 10 * 1024 * 1024;
export const ARTICLE_VIDEO_MAX_COUNT = 1;
export const ARTICLE_VIDEO_MAX_BYTES = 50 * 1024 * 1024;
export const ARTICLE_VIDEO_MAX_DURATION_SEC = 300;
export const ARTICLE_BODY_TEXT_MAX_CHARS = 100_000;
export const ARTICLE_TITLE_MAX_CHARS = 120;
export const ARTICLE_SUBTITLE_MAX_CHARS = 200;
export const ARTICLE_EXCERPT_MAX_CHARS = 300;
export const ARTICLE_SEO_TITLE_MAX_CHARS = 60;
export const ARTICLE_SEO_DESCRIPTION_MAX_CHARS = 160;
export const ARTICLE_SLUG_MAX_CHARS = 255;
